module.exports = __webpack_public_path__ + "img/logout.6197df67.svg";